import localFont from "next/font/local";
import type { DxFontId } from "@/lib/dx-fonts";

// Each DX font self-hosts via next/font/local (like Söhne), preload:false so
// only the exhibit's *selected* font is ever fetched (its .variable class is
// applied to .dx-theme in DigitalExhibitTheme; the others stay inert). The
// .variable exposes --font-dx-<id>, mapped to --dx-font in _dx-typography.scss.
const barlow = localFont({
  src: [
    { path: "../assets/fonts/dx/barlow-500.woff2", weight: "500" },
    { path: "../assets/fonts/dx/barlow-600.woff2", weight: "600" },
  ],
  variable: "--font-dx-barlow", display: "swap", preload: false, fallback: ["sans-serif"],
});
const raleway = localFont({
  src: [
    { path: "../assets/fonts/dx/raleway-400.woff2", weight: "400" },
    { path: "../assets/fonts/dx/raleway-600.woff2", weight: "600" },
    { path: "../assets/fonts/dx/raleway-700.woff2", weight: "700" },
    { path: "../assets/fonts/dx/raleway-800.woff2", weight: "800" },
  ],
  variable: "--font-dx-raleway", display: "swap", preload: false, fallback: ["sans-serif"],
});
const syne = localFont({
  src: [
    { path: "../assets/fonts/dx/syne-400.woff2", weight: "400" },
    { path: "../assets/fonts/dx/syne-600.woff2", weight: "600" },
    { path: "../assets/fonts/dx/syne-700.woff2", weight: "700" },
  ],
  variable: "--font-dx-syne", display: "swap", preload: false, fallback: ["sans-serif"],
});
const playfairDisplay = localFont({
  src: [
    { path: "../assets/fonts/dx/playfair-display-400.woff2", weight: "400" },
    { path: "../assets/fonts/dx/playfair-display-500.woff2", weight: "500" },
    { path: "../assets/fonts/dx/playfair-display-600.woff2", weight: "600" },
    { path: "../assets/fonts/dx/playfair-display-700.woff2", weight: "700" },
  ],
  variable: "--font-dx-playfair-display", display: "swap", preload: false, fallback: ["serif"],
});
const oswald = localFont({
  src: [
    { path: "../assets/fonts/dx/oswald-400.woff2", weight: "400" },
    { path: "../assets/fonts/dx/oswald-500.woff2", weight: "500" },
    { path: "../assets/fonts/dx/oswald-600.woff2", weight: "600" },
    { path: "../assets/fonts/dx/oswald-700.woff2", weight: "700" },
  ],
  variable: "--font-dx-oswald", display: "swap", preload: false, fallback: ["sans-serif"],
});
const heptaSlab = localFont({
  src: [
    { path: "../assets/fonts/dx/hepta-slab-400.woff2", weight: "400" },
    { path: "../assets/fonts/dx/hepta-slab-600.woff2", weight: "600" },
    { path: "../assets/fonts/dx/hepta-slab-700.woff2", weight: "700" },
    { path: "../assets/fonts/dx/hepta-slab-800.woff2", weight: "800" },
  ],
  variable: "--font-dx-hepta-slab", display: "swap", preload: false, fallback: ["serif"],
});
// Variable font: one file across the wght axis. SOFT 0 / WONK 1 is pinned in
// CSS (_dx-typography.scss), not here — those are not @font-face descriptors.
const fraunces = localFont({
  src: "../assets/fonts/dx/fraunces-variable.woff2",
  weight: "100 900",
  variable: "--font-dx-fraunces", display: "swap", preload: false, fallback: ["serif"],
});

const DX_FONT_CLASS: Record<DxFontId, string> = {
  sohne: "",
  barlow: barlow.variable,
  fraunces: fraunces.variable,
  raleway: raleway.variable,
  syne: syne.variable,
  "playfair-display": playfairDisplay.variable,
  oswald: oswald.variable,
  "hepta-slab": heptaSlab.variable,
};

export function dxFontVariableClass(id: DxFontId): string {
  return DX_FONT_CLASS[id] ?? "";
}
